import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_txn_line_RowClass, bl_inv_txn_sub_line_RowClass} from '../../../dbschema';

export class InventoryTransactionLineContainerModel extends BaseContainerModel {
  bl_inv_txn_line: bl_inv_txn_line_RowClass = new bl_inv_txn_line_RowClass();
  bl_inv_txn_sub_lines: bl_inv_txn_sub_line_RowClass[] = [];
}




